import { SVGProps } from 'react';

export default function Collapse(props: Partial<SVGProps<any>>) {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none" {...props}>
    <rect width="42" height="42" fill="none"/>
    <path d="M25 30L17 21L25 12L25 30Z" className='fill-primary-300 dark:fill-white'/>
  </svg>
  )
}